// extracted by mini-css-extract-plugin
export var container = "partnership-module--container--088e6";
export var content = "partnership-module--content--10dc2";
export var fellowshipPage = "partnership-module--fellowshipPage--68b67";
export var slideUp = "partnership-module--slideUp--a4ee8";
export var slideUpLarge = "partnership-module--slideUpLarge--0f001";
export var wrap = "partnership-module--wrap--5955d";